// the comments in this file are only application with the product_statuses_eureka flipper ON

enum AvailabilityStatus {
  AVAILABLE = "Available",
  IN_STOCK = "In Stock",
  BACKORDERED = "Backordered", // we use this value for Backordered tags in the catalog
  VENDOR_BACKORDERED = "Vendor backorder",
  UNAVAILABLE = "Unavailable", // we use this value for Out of Stock tags in the catalog
  DISCONTINUED = "Discontinued",
  TO_BE_DISCONTINUED = "To be discontinued",
  NA = "n/a", // we use this value for Unavailable tags in the catalog
  NEW = "New",
  NOT_IN_CATALOG = "Not in catalog", // we use this value for Wellevate products that don't exist in Fullscript
  FULLY_RESTRICTED = "Restricted", // Fully restricted products are products practitioner cannot prescribe (different from regular restricted products that are prescription only)
}
type AvailabilityStatusValueType = `${AvailabilityStatus}`;

const PRODUCT_SWAP_AVAILABILITY_STATUS = {
  discontinued: "discontinued",
  outOfStock: "out-of-stock",
} as const;

type ProductSwapAvailabilityStatus =
  (typeof PRODUCT_SWAP_AVAILABILITY_STATUS)[keyof typeof PRODUCT_SWAP_AVAILABILITY_STATUS];

export {
  AvailabilityStatus,
  type AvailabilityStatusValueType,
  PRODUCT_SWAP_AVAILABILITY_STATUS,
  type ProductSwapAvailabilityStatus,
};
